import React from "react";
import { Form, Checkbox, Row, Col } from "antd";

interface Props {
  activeQuestion?: any
  form?: any
}

const question = "What does your skin sensitivity look like?";

const JumpMultipleSelectQuestion: React.FC<Props> = (props) => {
  const { activeQuestion, form } = props;
  return (
    <div className="answer-input-wrapper">
      <Form.Item
        className="questionlist-checkbox"
        name={question}
        rules={[
          { required: true, message: "You have to select alteast one option" },
        ]}
      >
        <Checkbox.Group
        // onChange={(val?: any) => {
        //   form.setFieldsValue({ question: val })
        // }}
        >
          <Row>
            <Col span={24} key="1">
              <Checkbox value="Redness" key="1">
                Redness
              </Checkbox>
            </Col>
            <Col span={24} key="2">
              <Checkbox value="Dry/Flaky patches" key="2">
                Dry/ flaky patches
              </Checkbox>
            </Col>
            <Col span={24} key="3">
              <Checkbox value="Burning or itching sensation" key="3">
                Burning or itching sensation
              </Checkbox>
            </Col>
            <Col span={24} key="4">
              <Checkbox value="Medical Condition" key="4">
                Medical condition (eg. eczema, dermatitis, rosacea)
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Form.Item>
    </div>
  );
};

export default JumpMultipleSelectQuestion;
